module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/all-caregories/subcat/subcat.component.css
// module id = ./src/app/pages/all-caregories/subcat/subcat.component.css
// module chunks = main